<template>
  <div class="skeleton-container">
    <div class="image-skeleton">
      <v-skeleton-loader type="image"></v-skeleton-loader>
    </div>
    <div class="card-skeleton">
      <v-skeleton-loader type="heading"></v-skeleton-loader>
      <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
      <v-skeleton-loader type="list-item"></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "../../../sass/variables";
.blog-wrapper {
  .skeleton-container {
    --skeleton-width: 544px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    @media (max-width: $blog-desktop-breakpoint) {
      flex-direction: column;
    }
  }

  .image-skeleton {
    .v-skeleton-loader {
      border-radius: 20px;
      &__image {
        width: var(--skeleton-width);
        @media (max-width: $blog-desktop-breakpoint) {
          width: 100%;
        }
        height: 400px;
      }
    }
  }

  .card-skeleton {
    width: var(--skeleton-width);
    @media (max-width: $blog-desktop-breakpoint) {
      width: 100%;
      padding: 2rem 0;
    }
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .v-skeleton-loader__heading {
      width: 100%;
    }
    .v-skeleton-loader__list-item-three-line {
      padding: 0;
    }
    .v-skeleton-loader__list-item {
      width: 120px;
      padding: 0;
    }
  }
}
</style>